// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hotel-message-bar {
  display: grid;
  background: #ffffff;
  border: 1.5px solid #1a6a7c;
  border-radius: 1.5vw;
  text-align: center;
  place-items: center;
  height: 2.2vw;
  padding: 0.1vw;
  margin: 0.1vw;
  color: #1a6a7c;
  font-size: 1.3vw;
}

.hotel-top-bar {
  display: grid;
  grid-template-columns: auto max-content 16vw;
  width: 94vw;
}

.hotel-icon {
  cursor: pointer;
  height: 100%;
  margin-left: 0.5vw;
  width: 2.2vw;
}

.hotel-subtitle {
  display: grid;
  margin-left: 4.5vw;
  font-size: 2vw;
  margin-bottom: 0;
  margin-top: 0;
  line-height: 1;
}
.hotel-icon:not(.blocked):active {
  filter: brightness(0.8);
}
.hotel-icon.blocked {
  filter: brightness(0.6);
  cursor: not-allowed;
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Stevehotel/styles/HotelTopBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".hotel-message-bar {\n  display: grid;\n  background: #ffffff;\n  border: 1.5px solid #1a6a7c;\n  border-radius: 1.5vw;\n  text-align: center;\n  place-items: center;\n  height: 2.2vw;\n  padding: 0.1vw;\n  margin: 0.1vw;\n  color: #1a6a7c;\n  font-size: 1.3vw;\n}\n\n.hotel-top-bar {\n  display: grid;\n  grid-template-columns: auto max-content 16vw;\n  width: 94vw;\n}\n\n.hotel-icon {\n  cursor: pointer;\n  height: 100%;\n  margin-left: 0.5vw;\n  width: 2.2vw;\n}\n\n.hotel-subtitle {\n  display: grid;\n  margin-left: 4.5vw;\n  font-size: 2vw;\n  margin-bottom: 0;\n  margin-top: 0;\n  line-height: 1;\n}\n.hotel-icon:not(.blocked):active {\n  filter: brightness(0.8);\n}\n.hotel-icon.blocked {\n  filter: brightness(0.6);\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
